import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState, useRef } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useNavigate,
} from "react-router-dom";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import * as XLSX from "xlsx";

import "react-calendar/dist/Calendar.css";
import {
  GetFeeCollectionReport,
  GetFeeReport,
} from "../../../api/ReportsServices";
import { getBatchList } from "../../../api/BatchService";
import { LoadingDiv } from "../../master/Master";
import { getSessions } from "../../../api/SessionsService";
import { StaffList } from "../../../api/Staff";
import ReportLayout from "./ReportLayout";

export default function Reports2() {
  const hasAccess = usePrivateLink();
  const [activeTab, setActiveTab] = useState(null);
  const [page, setPage] = useState(1);
  const [Data, setData] = useState(null);
  const [total, setTotal] = useState(0);
  const [batches, setBatches] = useState([]);
  const [staffs, setStaffs] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [name, setName] = useState("");
  const [batchId, setBatchID] = useState("");
  const [staffId, setStaffId] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedSession, setSelectedSessions] = useState("");
  const [sessions, setSessions] = useState([]);
  const [error, setError] = useState("");
  const [transition, setTransition] = useState([]);
  const [type, setType] = useState("");
  const navigate = useNavigate();

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1",
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  const handleExportAll = async () => {
    try {
      setLoading(true);
      let allData = [];

      // First fetch page 1 to get last_page info
      const firstResponse = await GetFeeCollectionReport("?page=1");
      const lastPage = firstResponse?.data?.data?.last_page || 1;

      // Loop through all pages
      for (let page = 1; page <= lastPage; page++) {
        const response = await GetFeeCollectionReport(`page=${page}`);
        const records = response?.data?.data?.data || [];
        allData.push(...records);
      }

      if (allData.length === 0) {
        alert("No data to export!");
        return;
      }

      // Flatten and safe mapping
      const formattedData = allData.map((item) => ({
        "Student Name": item.student?.name || "",
        "registration No": item.student?.registration_no || "",
        "registration No": item.student?.registration_no || "",
        "Mobile Number": item.student?.phone || "",
        "Batch Name": item.batch?.title || "",
        Amount: item.amount || 0,
        "Payment Method": item.payment_method || "",
        "Fee Date": item.fee_date || "",
        "Next Payment Date": item.next_payment_date || "",
        Description: item.description || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fee Collection");
      XLSX.writeFile(workbook, "FeeCollection.xlsx");

      alert(`Exported ${allData.length} records successfully!`);
    } catch (error) {
      console.error(error);
      alert(`Error in exporting: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const loadOnce = useRef(false);

  const fetchData = async () => {
    setLoading(true);
    let addUrl = `&page=${page}&session_id=${selectedSession}`;
    if (from) addUrl += `&start_date=${from}`;
    if (to) addUrl += `&end_date=${to}`;
    if (batchId) addUrl += `&batch_id=${batchId}`;
    if (staffId) addUrl += `&staff_id=${staffId}`;
    if (name) addUrl += `&search=${name}`;
    try {
      const response = await GetFeeReport(addUrl);
      setData(response?.data?.data);
      setTransition(response.data?.data || []);
      setTotal(response?.data?.total_sum);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };
  const filteredData = Data?.reportData?.filter((item) => {
    const itemDate = new Date(item.date); // Assuming each record has a "date" field
    const fromDate = new Date(from);
    const toDate = new Date(to);
    return (!from || itemDate >= fromDate) && (!to || itemDate <= toDate);
  });

  const getBatches = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      let response = await getBatchList(addUrl);

      setBatches(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStaffs = async () => {
    setLoading(true);
    try {
      let response = await StaffList();
      setStaffs(response?.data?.batches);
    } catch (error) {
      console.error("Failed to fetch chart data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getStaffs();
  }, []);

  useEffect(() => {
    getBatches();
  }, [selectedSession]);

  useEffect(() => {
    setPage(1);
    setFrom("");
    setTo("");
    setStaffId("");
    setBatchID("");
  }, [activeTab]);

  useEffect(() => {
    fetchData();
  }, [
    activeTab,
    page,
    from,
    to,
    batchId,
    staffId,
    name,
    selectedSession,
    type,
  ]);

  useEffect(() => {
    if (
      !loadOnce.current &&
      Data &&
      // activeTab == "overview"
      Data?.graph &&
      Data?.batchWise
    ) {
      // alert('hello')
      const existingScript = document.querySelector(
        'script[src="/assets/js/report.js"]',
      );
      if (existingScript) {
        existingScript.remove();
      }

      // totalProfitChart
      window.DasChartCategories = Data?.graph?.months || [];
      window.PresentStudent = Data?.graph?.collection || [];
      window.AbsentStudent = Data?.graph?.expenses || [];

      window.DasChartCategories2 =
        Data?.["7day_summary"]?.day_graph?.days || [];
      window.PresentStudent2 =
        Data?.["7day_summary"]?.day_graph?.collection || [];
      window.AbsentStudent2 = Data?.["7day_summary"]?.day_graph?.expenses || [];

      window.DasChartCategories3 = Data?.attendance?.days || [];
      window.PresentStudent3 = Data?.attendance?.student?.present || [];
      window.AbsentStudent3 = Data?.attendance?.student?.absent || [];

      window.DasChartCategories4 = Data?.attendance?.days || [];
      window.PresentStudent4 = Data?.attendance?.staff?.present || [];
      window.AbsentStudent4 = Data?.attendance?.staff?.absent || [];

      const value = Data?.total_Collection - Data?.total_expenses;
      window.CollectionExpense = ["Collection", "Expense"];
      window.CollectionExpenseData = [
        Number(Data?.total_Collection ?? 0),
        Number(Data?.total_expenses ?? 0),
      ];
      window.CollectionExpenseStatus = value > 0 ? "Profit" : "Lose";
      window.CollectionExpenseStatusData = Math.abs(value) ?? 0;

      window.BatchList = Data?.batchWise?.batch || [];
      window.BatchDeu = Data?.batchWise?.pending || [];
      window.BatchTotal = Data?.batchWise?.final || [];

      const script = document.createElement("script");
      script.src = "/assets/js/report.js";
      script.async = true;
      document.body.appendChild(script);
      loadOnce.current = true;
    }
  }, [Data, activeTab]);
  const routeToTab = {
    "/student/due/fee": "feeDues",
    "/reports/expense/report": "expense",
    "/reports/credit/debit": "collection",
    "/reports": "overview",
  };

  useEffect(() => {
    const matchingRoute = Object.keys(routeToTab).find((route) =>
      hasAccess(route),
    );
    if (matchingRoute) setActiveTab(routeToTab[matchingRoute]);
  }, [hasAccess]);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <>
              {/* Content */}
              <div className="container-fluid mt-2">
                <div className="row">
                  <ReportLayout />
                  <div className="col-12">
                    <div className="row gy-6">
                      <div className="d-flex">
                        <h5 className="mb-3 text-primary">Overview Report</h5>
                        <div className="ms-auto">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              name="session"
                              value={selectedSession}
                              onChange={(e) =>
                                setSelectedSessions(e.target.value)
                              }
                            >
                              {/* <option value="">Select Session</option> */}
                              {sessions?.map((session) => (
                                <option key={session?.id} value={session?.id}>
                                  {session?.session}:
                                  {session?.status == "1"
                                    ? "Active"
                                    : " Inactive"}
                                  {/* Show "2023-24" */}
                                </option>
                              ))}
                            </select>

                            <label>Filter Session</label>
                          </div>
                        </div>
                      </div>
                      {/* Total Transactions & Report Chart */}
                      <div className="col-12 col-xl-8">
                        <div className="card h-100">
                          <div className="row">
                            <div className="col-md-7 pe-md-0">
                              <div className="card-header">
                                <h5 className="mb-0 text-primary fw-semibold">
                                  Financial Year Report
                                </h5>
                              </div>
                              <div className="card-body">
                                <div id="totalProfitChart" />
                              </div>
                            </div>
                            <div className="col-md-5 border-start ps-md-0">
                              <hr className="d-block d-md-none my-0" />
                              <div className="card-header">
                                <div className="d-flex justify-content-between">
                                  <h5 className="mb-0 text-primary">
                                    {Data?.total_students}
                                  </h5>
                                </div>
                                <p className=" mb-0">
                                  Total Students {Data?.session}
                                </p>
                              </div>
                              <div className="card-body pt-3">
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-primary rounded">
                                      <i className="ri-wallet-line ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-primary fw-semibold">
                                      ₹ {Data?.total_Collection}
                                    </h6>
                                    <p className="mb-0">Total Collection</p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-info rounded">
                                      <i className="ri-bank-card-line ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-info fw-semibold">
                                      ₹ {Data?.total_expenses}
                                    </h6>
                                    <p className="mb-0">Total Expense</p>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center mb-4">
                                  <div className="avatar">
                                    <div className="avatar-initial bg-label-danger rounded">
                                      <i className="ri-group-fill ri-24px" />
                                    </div>
                                  </div>
                                  <div className="ms-3 d-flex flex-column">
                                    <h6 className="mb-1 text-danger fw-semibold">
                                      ₹ {Data?.pending_fees}
                                    </h6>
                                    <p className="mb-0 ">Total Due Fees</p>
                                  </div>
                                </div>
                                <div>
                                  <button
                                    className="btn btn-primary w-100"
                                    type="button"
                                    data-bs-toggle="modal"
                                    data-bs-target="#report"
                                  >
                                    View Report
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*/ Total Profit Chart & Last month balance */}
                      {/* Total Visitors Chart */}
                      <div className="col-xl-4 col-md-6">
                        <div className="card h-100">
                          <div className="card-header pb-1">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Financial Year Profit & lose
                              </h5>
                            </div>
                          </div>
                          <div className="card-body">
                            <div id="salesOverviewChart"></div>
                          </div>
                        </div>
                      </div>
                      {/*/ Total Visitors Chart */}
                      {/* Weekly Sales Chart */}
                      <div className="col-xl-8 col-md-6">
                        <div className="card h-100">
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Last 7 Days Report
                              </h5>
                            </div>
                            <p className="text-mute mb-0">
                              7 Days Expenses & Collection
                            </p>
                          </div>
                          <div className="card-body">
                            <div id="totalProfitChart2" />
                          </div>
                        </div>
                      </div>
                      {/*/ Weekly Sales Chart */}

                      {/* Last 7 days chart*/}
                      <div className="col-xl-4 col-md-6">
                        <div className="card border-start ps-md-0">
                          <hr className="d-block d-md-none my-0" />
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Last 7 Today`s Collection{" "}
                              </h5>
                            </div>
                            <p className=" mb-5">
                              Profit , Collection and Expenses
                            </p>
                          </div>
                          <div className="card-body pt-5">
                            {/* Profit */}

                            {(() => {
                              const value =
                                Data?.["7day_summary"]?.day_graph?.net?.reduce(
                                  (sum, val) => sum + val,
                                  0,
                                ) || 0;

                              return (
                                <>
                                  <div className="d-flex align-items-center mb-5 mt-3">
                                    <div className="avatar">
                                      <div className="avatar-initial bg-label-success rounded">
                                        <i
                                          className={`${
                                            value > 0
                                              ? "ri-arrow-up-line"
                                              : "ri-arrow-down-line"
                                          } ri-24px`}
                                        ></i>
                                      </div>
                                    </div>
                                    <div className="ms-3 d-flex flex-column">
                                      <h6 className="mb-1 text-primary fw-semibold">
                                        ₹ {Math.abs(value)}
                                      </h6>
                                      <p className="mb-0">
                                        {value > 0
                                          ? "Profit"
                                          : value < 0
                                            ? "Lose"
                                            : "Break-even"}
                                      </p>
                                    </div>
                                  </div>
                                </>
                              );
                            })()}

                            {/* Total Collection */}
                            <div className="d-flex align-items-center mb-5">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-primary rounded">
                                  <i className="ri-money-dollar-circle-line ri-24px" />{" "}
                                  {/* Collection icon */}
                                </div>
                              </div>
                              <div className="ms-3 d-flex flex-column">
                                <h6 className="mb-1 text-primary fw-semibold">
                                  ₹{" "}
                                  {Data?.[
                                    "7day_summary"
                                  ]?.day_graph?.collection?.reduce(
                                    (sum, val) => sum + val,
                                    0,
                                  ) || 0}
                                </h6>
                                <p className="mb-0">Total Collection</p>
                              </div>
                            </div>

                            {/* Total Expense */}
                            <div className="d-flex align-items-center mb-5">
                              <div className="avatar">
                                <div className="avatar-initial bg-label-secondary rounded">
                                  <i className="ri-wallet-3-line ri-24px" />{" "}
                                  {/* Expense icon */}
                                </div>
                              </div>
                              <div className="ms-3 d-flex flex-column mb-5">
                                <h6 className="mb-1 text-primary fw-semibold">
                                  ₹{" "}
                                  {Data?.[
                                    "7day_summary"
                                  ]?.day_graph?.expenses?.reduce(
                                    (sum, val) => sum + val,
                                    0,
                                  ) || 0}
                                </h6>
                                <p className="mb-0">Total Expense</p>
                              </div>
                            </div>

                            <div className="mt-5">
                              {/* <button
                              className="btn btn-primary w-100"
                              type="button"
                            >
                              View Report
                            </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 mb-6">
                        <div className="card">
                          <div className="card-header header-elements">
                            <h5 className="card-title mb-0">
                              Batch wise fee report
                            </h5>
                          </div>
                          <div className="card-body pt-2">
                            <div id="lineAreaChart"></div>
                          </div>
                        </div>
                      </div>

                      {/*/ Last 7 days chart*/}
                      {/* Teacher Attendance Chart */}
                      <div className="col-xl-6 col-md-6">
                        <div className="card h-100">
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-1 text-primary fw-semibold">
                                Weekly Faculty Presence Report
                              </h5>
                            </div>
                          </div>
                          <div className="card-body pt-0">
                            <div id="totalProfitChart3" />
                          </div>
                        </div>
                      </div>
                      {/*/ Teacher Attendance Chart */}
                      {/* Analytics Chart */}
                      <div className="col-xl-6 col-md-6">
                        <div className="card h-100">
                          <div className="card-header">
                            <div className="d-flex justify-content-between">
                              <h5 className="mb-0 text-primary fw-semibold">
                                Weekly Students Presence Report
                              </h5>
                            </div>
                          </div>
                          <div className="card-body pt-0">
                            <div id="totalProfitChart4" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          </div>
        </div>
        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
      </div>

      <div
        className="modal fade"
        id="report"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <form>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5">Reports View</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-4 col-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        name="session"
                        value={selectedSession}
                        onChange={(e) => setSelectedSessions(e.target.value)}
                      >
                        {/* <option value="">Select Session</option> */}
                        {sessions?.map((session) => (
                          <option key={session?.id} value={session?.id}>
                            {session?.session}:
                            {session?.status == "1" ? "Active" : " Inactive"}
                            {/* Show "2023-24" */}
                          </option>
                        ))}
                      </select>

                      <label>Filter Session</label>
                    </div>
                  </div>
                </div>
                {/* Data Summary (Aligned horizontally) */}
                <div className="row mb-4">
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-primary">{Data?.total_students}</h5>
                      <p>Total Students</p>
                    </div>
                  </div>

                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-success">
                        ₹ {Data?.total_Collection}
                      </h5>
                      <p>Total Collection</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-danger">₹ {Data?.total_expenses}</h5>
                      <p>Total Expense</p>
                    </div>
                  </div>
                  <div className="col-6 col-md-3 mt-2">
                    <div className="card p-3 text-center">
                      <h5 className="text-danger">₹ {Data?.pending_fees}</h5>
                      <p>Total Due Fees</p>
                    </div>
                  </div>
                </div>

                {/* Date Filters */}
                {/* <div className="row d-flex">
                  <div className="col-md-3 col-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      id="fromDate"
                      className="form-control"
                      value={from}
                      onChange={e => setFrom(e.target.value)}
                    />
                    <label>From Date</label>
                  </div>
                  <div className="col-md-3 col-6 form-floating form-floating-outline">
                    <input
                      type="date"
                      id="toDate"
                      className="form-control"
                      value={to}
                      onChange={e => setTo(e.target.value)}
                    />
                    <label>To Date</label>
                  </div>
                  <div className="col-md-3 col-6 d-flex align-items-center">
                     <button
                      onClick={() => {
                        const today = new Date();
                        const sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(today.getDate() - 6);
                        const formatDate = (date) => date.toISOString().split("T")[0];
                        setTo(formatDate(today));
                        setFrom(formatDate(today));
                      }}
                      className="btn btn-sm btn-primary me-2"
                    >
                      Today
                    </button>
                    <button
                      onClick={() => {
                        const today = new Date();
                        const sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(today.getDate() - 6);
                        const formatDate = (date) => date.toISOString().split("T")[0];
                        setTo(formatDate(today));
                        setFrom(formatDate(sevenDaysAgo));
                      }}
                      className="btn btn-sm btn-primary"
                    >
                      7 Days
                    </button>
                  </div>

                </div> */}

                {/* Table to display filtered data */}
                <div className="table-responsive">
                  <table className="table text-center hovered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Session</th>
                        <th>Collection</th>
                        <th>Expense</th>
                        {/* <th>Pending Fees</th>
                        <th>Total Students</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {Data ? (
                        <tr>
                          <td>1</td>
                          <td>{Data.session}</td>
                          <td>₹ {Data.total_Collection}</td>
                          <td>₹ {Data.total_expenses}</td>
                          {/* <td>₹ {Data.pending_fees}</td>
                          <td>{Data.total_students}</td> */}
                        </tr>
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center text-muted">
                            No data found for the selected date range
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer with Buttons */}
              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
